// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__LEGXG","button":"styles_button__MmfLs","icon":"styles_icon__P3c3S"};